import { render, staticRenderFns } from "./official.vue?vue&type=template&id=2fc0cc1a&scoped=true&"
import script from "./official.vue?vue&type=script&lang=js&"
export * from "./official.vue?vue&type=script&lang=js&"
import style0 from "./official.vue?vue&type=style&index=0&id=2fc0cc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0cc1a",
  null
  
)

export default component.exports